export default {
  'menu.afr': 'AFR',
  'menu.afr.new': 'New AFR',
  'menu.afr.list': 'AFR List',
  'menu.afr.afr_new': 'New AFR',
  'menu.afr.afr_list': 'Search',
  'afr.title.new': 'New Japan AFR',
  'afr.tab.info': 'Info',
  'afr.tab.documents': 'Documents',
  'afr.section.filing': 'Filing & Route Information',
  'afr.section.containers': 'Master Containers',
  'afr.section.houses': 'Houses',
  'afr.section.parties': 'Shipping Parties',
  'afr.field.status': 'Status',
  'afr.field.masterBillNo': 'Master B/L No.',
  'afr.field.houseNo': 'House B/L No.',
  'afr.field.filingType': 'Filing Type',
  'afr.field.filerCode': 'Filer Code',
  'afr.field.opType': 'Operation Type',
  'afr.field.originAgent': 'Origin Agent Code',
  'afr.field.destinationAgent': 'Destination Agent Code',
  'afr.field.carrier': 'Carrier',
  'afr.field.carrierName': 'Carrier Name',
  'afr.field.carrierCode': 'Carrier Code',
  'afr.field.consignmentType': 'Consignment Type',
  'afr.field.departureVessel': 'Departure Vessel',
  'afr.field.arrivalVessel': 'Arrival Vessel',
  'afr.field.voyage': 'Voyage No.',
  'afr.field.imo': 'IMO No.',
  'afr.field.flag': 'Flag',
  'afr.field.callSign': 'Call Sign',
  'afr.field.loadingPort': 'Loading Port',
  'afr.field.transhipPort': 'Transhipment Port',
  'afr.field.dischargePort': 'Discharge Port',
  'afr.field.destinationPort': 'Destination Port',
  'afr.field.date': 'Date',
  'afr.field.masterRefNo': 'Master Reference No.',
  'afr.field.containerNo': 'Container No.',
  'afr.field.containerType': 'Container Type',
  'afr.field.sealNo': 'Seal No.',
  'afr.field.sealNo2': 'Seal No. 2',
  'afr.field.serviceCode': 'Service Code',
  'afr.field.shipperOwned': 'Shipper Owned',
  'afr.field.shipperRef': 'Shipper Ref. Code',
  'afr.field.consigneeRef': 'Consignee Ref. Code',
  'afr.field.notifyRef': 'Notify Ref. Code',
  'afr.field.secondNotifyParty': 'Second Notify Party',
  'afr.field.lastHblIndicator': 'Last HBL Indicator',
  'afr.field.receiptPlace': 'Place of Receipt',
  'afr.field.deliveryPlace': 'Place of Delivery',
  'afr.field.quantity': 'Package Quantity',
  'afr.field.packageUnit': 'Package Unit',
  'afr.field.unitName': 'Unit Name',
  'afr.field.unitClassOwner': 'Unit Class Owner',
  'afr.field.grossWeight': 'Gross Weight',
  'afr.field.weightUnit': 'Weight Unit',
  'afr.field.cbm': 'CBM',
  'afr.field.houseRefNo': 'House Reference No.',
  'afr.field.remark': 'Remark',
  'afr.field.containerRef': 'Container Ref. No.',
  'afr.field.originCountry': 'Country of Origin',
  'afr.field.marking': 'Marking',
  'afr.field.description': 'Cargo Description',
  'afr.field.hsNumber': 'HS Number',
  'afr.field.unNo': 'UNDG Number',
  'afr.field.imoClass': 'IMO Class',
  'afr.field.packingGroup': 'Packing Group',
  'afr.field.flashPoint': 'Flash Point',
  'afr.field.flashpointUom': 'Flash Point UOM',
  'afr.field.hazardousComments': 'Hazardous Goods Comments',
  'afr.field.emergencyName': 'Emergency Contact',
  'afr.field.emergencyPhone': 'Emergency Phone',
  'afr.field.partyCode': 'Party Code',
  'afr.field.partyType': 'Party Type',
  'afr.field.partyName': 'Party Name',
  'afr.field.partyGroup': 'Group Code',
  'afr.field.partyIdType': 'Party ID Type',
  'afr.field.partyId': 'Tax ID',
  'afr.field.addressLines': 'Address Lines',
  'afr.field.city': 'City',
  'afr.field.subdivision': 'State / Province',
  'afr.field.postalCode': 'Postal Code',
  'afr.field.country': 'Country',
  'afr.field.contactName': 'Contact Name',
  'afr.field.email': 'Email',
  'afr.field.phone': 'Phone',
  'afr.field.phoneArea': 'Phone Area',
  'afr.field.fax': 'Fax',
  'afr.field.faxArea': 'Fax Area',
  'afr.status.new': 'New',
  'afr.status.submitted': 'Submitted',
  'afr.status.received': 'Received',
  'afr.status.accepted': 'Accepted',
  'afr.status.masterRegistered': 'Master Registered',
  'afr.status.hold': 'Hold',
  'afr.status.holdReleased': 'Hold Released',
  'afr.status.rejected': 'Rejected',
  'afr.status.cancelled': 'Cancelled',
  'afr.status.unknown': 'Unknown',
  'afr.action.add': 'Add',
  'afr.action.edit': 'Edit',
  'afr.action.sync': 'Sync Status',
  'afr.action.previewXml': 'Preview XML',
  'afr.action.copy': 'Copy',
  'afr.action.void': 'Void',
  'afr.action.addCargo': 'Add Cargo',
  'afr.action.editCargo': 'Edit Cargo',
  'afr.save.success': 'AFR draft saved.',
  'afr.submit.success': 'AFR submitted.',
  'afr.sync.success': 'AFR status synchronized.',
  'afr.sync.partial': 'AFR status query completed with provider errors.',
  'afr.void.success': 'AFR filing voided.',
  'afr.void.confirm':
    'Void this AFR filing? Submitted filings will send a deletion to E-Freight first.',
  'afr.validation.masterBillRequired': 'Master B/L number is required.',
  'afr.validation.filingType': 'Filing type must be Import or Transshipment.',
  'afr.validation.houseRequired': 'At least one house is required.',
  'afr.validation.houseNoRequired': 'House B/L number is required.',
  'afr.validation.hsNumber': 'HS number must contain 6 to 10 digits.',
  'afr.validation.partiesRequired': 'At least shipper and consignee parties are required.',
  'afr.validation.partyNameRequired': 'Party name is required.',
  'afr.validation.summary': 'Please correct {count} AFR filing problem(s) before submission.',
  'afr.changelog.provider': 'Japan Customs / E-Freight',
  'afr.changelog.risk': 'Risk Assessment',
  'afr.list.create': 'Create AFR',
  'afr.list.houseCount': 'Houses',
  'afr.list.vesselVoyage': 'Vessel / Voyage',
  'afr.list.route': 'POL / POD',
  'afr.list.lastDisposition': 'Last Disposition',
  'afr.list.owner': 'Owner',
};
